/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BulkSuborderWithOrder,
  ExportBulkSubordersParams,
  GetBulkSuborderPackingListParams,
  GetBulkSubordersParams,
  HTTPValidationError,
  MarkBulkSuborderDeliveredParams,
  PageBulkSuborderLookup,
  SplitBulkSuborderProductParams,
  UpdateBulkSuborderFulfillerParams,
  UpdateBulkSuborderFulfillmentNoteParams,
  UpdateBulkSuborderProductLotInfoParams,
  UpdateBulkSuborderProductUnitPriceParams,
  UpdateBulkSuborderProductWholesalePriceParams,
  UpdateBulkSuborderShipToBody,
  UpdateBulkSuborderShippingSpeedParams,
  UpdateBulkSuborderTargetShipByParams,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to get many bulk_suborders.

Results are paginated and filtered based on the current user's role.
 * @summary Get Bulk Suborders
 */
export const getBulkSuborders = (
  params?: GetBulkSubordersParams,
  signal?: AbortSignal,
) => {
  return customInstance<PageBulkSuborderLookup>({
    url: `/api/bulk_suborder/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetBulkSubordersQueryKey = (
  params?: GetBulkSubordersParams,
) => {
  return ["api", "bulk_suborder", ...(params ? [params] : [])] as const;
};

export const getGetBulkSubordersQueryOptions = <
  TData = Awaited<ReturnType<typeof getBulkSuborders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkSubordersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborders>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBulkSubordersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBulkSuborders>>
  > = ({ signal }) => getBulkSuborders(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBulkSuborders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBulkSubordersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBulkSuborders>>
>;
export type GetBulkSubordersQueryError = ErrorType<void | HTTPValidationError>;

export function useGetBulkSuborders<
  TData = Awaited<ReturnType<typeof getBulkSuborders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetBulkSubordersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborders>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkSuborders>>,
          TError,
          Awaited<ReturnType<typeof getBulkSuborders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkSuborders<
  TData = Awaited<ReturnType<typeof getBulkSuborders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkSubordersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborders>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkSuborders>>,
          TError,
          Awaited<ReturnType<typeof getBulkSuborders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkSuborders<
  TData = Awaited<ReturnType<typeof getBulkSuborders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkSubordersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborders>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bulk Suborders
 */

export function useGetBulkSuborders<
  TData = Awaited<ReturnType<typeof getBulkSuborders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkSubordersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborders>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBulkSubordersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Export bulk suborders to CSV with true streaming.
 * @summary Export Bulk Suborders
 */
export const exportBulkSuborders = (
  params?: ExportBulkSubordersParams,
  signal?: AbortSignal,
) => {
  return customInstance<Blob>({
    url: `/api/bulk_suborder/export`,
    method: "GET",
    params,
    responseType: "blob",
    signal,
  });
};

export const getExportBulkSubordersQueryKey = (
  params?: ExportBulkSubordersParams,
) => {
  return [
    "api",
    "bulk_suborder",
    "export",
    ...(params ? [params] : []),
  ] as const;
};

export const getExportBulkSubordersQueryOptions = <
  TData = Awaited<ReturnType<typeof exportBulkSuborders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportBulkSubordersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBulkSuborders>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportBulkSubordersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportBulkSuborders>>
  > = ({ signal }) => exportBulkSuborders(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportBulkSuborders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExportBulkSubordersQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportBulkSuborders>>
>;
export type ExportBulkSubordersQueryError =
  ErrorType<void | HTTPValidationError>;

export function useExportBulkSuborders<
  TData = Awaited<ReturnType<typeof exportBulkSuborders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | ExportBulkSubordersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBulkSuborders>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportBulkSuborders>>,
          TError,
          Awaited<ReturnType<typeof exportBulkSuborders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportBulkSuborders<
  TData = Awaited<ReturnType<typeof exportBulkSuborders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportBulkSubordersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBulkSuborders>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportBulkSuborders>>,
          TError,
          Awaited<ReturnType<typeof exportBulkSuborders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportBulkSuborders<
  TData = Awaited<ReturnType<typeof exportBulkSuborders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportBulkSubordersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBulkSuborders>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export Bulk Suborders
 */

export function useExportBulkSuborders<
  TData = Awaited<ReturnType<typeof exportBulkSuborders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportBulkSubordersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportBulkSuborders>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExportBulkSubordersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get an bulk_suborder by ID.
 * @summary Get Bulk Suborder
 */
export const getBulkSuborder = (
  bulkSuborderId: string,
  signal?: AbortSignal,
) => {
  return customInstance<BulkSuborderWithOrder>({
    url: `/api/bulk_suborder/${bulkSuborderId}`,
    method: "GET",
    signal,
  });
};

export const getGetBulkSuborderQueryKey = (bulkSuborderId?: string) => {
  return ["api", "bulk_suborder", bulkSuborderId] as const;
};

export const getGetBulkSuborderQueryOptions = <
  TData = Awaited<ReturnType<typeof getBulkSuborder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborder>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBulkSuborderQueryKey(bulkSuborderId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkSuborder>>> = ({
    signal,
  }) => getBulkSuborder(bulkSuborderId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!bulkSuborderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBulkSuborder>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBulkSuborderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBulkSuborder>>
>;
export type GetBulkSuborderQueryError = ErrorType<void | HTTPValidationError>;

export function useGetBulkSuborder<
  TData = Awaited<ReturnType<typeof getBulkSuborder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborder>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkSuborder>>,
          TError,
          Awaited<ReturnType<typeof getBulkSuborder>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkSuborder<
  TData = Awaited<ReturnType<typeof getBulkSuborder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborder>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkSuborder>>,
          TError,
          Awaited<ReturnType<typeof getBulkSuborder>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkSuborder<
  TData = Awaited<ReturnType<typeof getBulkSuborder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborder>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bulk Suborder
 */

export function useGetBulkSuborder<
  TData = Awaited<ReturnType<typeof getBulkSuborder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborder>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBulkSuborderQueryOptions(bulkSuborderId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get a PDF purchase order for a bulk_suborder by ID.
 * @summary Get Purchase Suborder
 */
export const getPurchaseSuborder = (
  bulkSuborderId: string,
  signal?: AbortSignal,
) => {
  return customInstance<Blob>({
    url: `/api/bulk_suborder/${bulkSuborderId}/purchase_suborder`,
    method: "GET",
    responseType: "blob",
    signal,
  });
};

export const getGetPurchaseSuborderQueryKey = (bulkSuborderId?: string) => {
  return ["api", "bulk_suborder", bulkSuborderId, "purchase_suborder"] as const;
};

export const getGetPurchaseSuborderQueryOptions = <
  TData = Awaited<ReturnType<typeof getPurchaseSuborder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchaseSuborder>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPurchaseSuborderQueryKey(bulkSuborderId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPurchaseSuborder>>
  > = ({ signal }) => getPurchaseSuborder(bulkSuborderId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!bulkSuborderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPurchaseSuborder>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPurchaseSuborderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPurchaseSuborder>>
>;
export type GetPurchaseSuborderQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetPurchaseSuborder<
  TData = Awaited<ReturnType<typeof getPurchaseSuborder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchaseSuborder>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPurchaseSuborder>>,
          TError,
          Awaited<ReturnType<typeof getPurchaseSuborder>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPurchaseSuborder<
  TData = Awaited<ReturnType<typeof getPurchaseSuborder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchaseSuborder>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPurchaseSuborder>>,
          TError,
          Awaited<ReturnType<typeof getPurchaseSuborder>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPurchaseSuborder<
  TData = Awaited<ReturnType<typeof getPurchaseSuborder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchaseSuborder>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Purchase Suborder
 */

export function useGetPurchaseSuborder<
  TData = Awaited<ReturnType<typeof getPurchaseSuborder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchaseSuborder>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPurchaseSuborderQueryOptions(
    bulkSuborderId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get a PDF packing list for a bulk_suborder by ID.
 * @summary Get Bulk Suborder Packing List
 */
export const getBulkSuborderPackingList = (
  bulkSuborderId: string,
  params?: GetBulkSuborderPackingListParams,
  signal?: AbortSignal,
) => {
  return customInstance<Blob>({
    url: `/api/bulk_suborder/${bulkSuborderId}/packing_list`,
    method: "GET",
    params,
    responseType: "blob",
    signal,
  });
};

export const getGetBulkSuborderPackingListQueryKey = (
  bulkSuborderId?: string,
  params?: GetBulkSuborderPackingListParams,
) => {
  return [
    "api",
    "bulk_suborder",
    bulkSuborderId,
    "packing_list",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetBulkSuborderPackingListQueryOptions = <
  TData = Awaited<ReturnType<typeof getBulkSuborderPackingList>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  params?: GetBulkSuborderPackingListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborderPackingList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBulkSuborderPackingListQueryKey(bulkSuborderId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBulkSuborderPackingList>>
  > = ({ signal }) =>
    getBulkSuborderPackingList(bulkSuborderId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!bulkSuborderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBulkSuborderPackingList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBulkSuborderPackingListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBulkSuborderPackingList>>
>;
export type GetBulkSuborderPackingListQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetBulkSuborderPackingList<
  TData = Awaited<ReturnType<typeof getBulkSuborderPackingList>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  params: undefined | GetBulkSuborderPackingListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborderPackingList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkSuborderPackingList>>,
          TError,
          Awaited<ReturnType<typeof getBulkSuborderPackingList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkSuborderPackingList<
  TData = Awaited<ReturnType<typeof getBulkSuborderPackingList>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  params?: GetBulkSuborderPackingListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborderPackingList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkSuborderPackingList>>,
          TError,
          Awaited<ReturnType<typeof getBulkSuborderPackingList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkSuborderPackingList<
  TData = Awaited<ReturnType<typeof getBulkSuborderPackingList>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  params?: GetBulkSuborderPackingListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborderPackingList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bulk Suborder Packing List
 */

export function useGetBulkSuborderPackingList<
  TData = Awaited<ReturnType<typeof getBulkSuborderPackingList>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  params?: GetBulkSuborderPackingListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborderPackingList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBulkSuborderPackingListQueryOptions(
    bulkSuborderId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get a PDF wholesale invoice for a bulk_suborder by ID.
 * @summary Get Bulk Suborder Wholesale Invoice
 */
export const getBulkSuborderWholesaleInvoice = (
  bulkSuborderId: string,
  signal?: AbortSignal,
) => {
  return customInstance<Blob>({
    url: `/api/bulk_suborder/${bulkSuborderId}/wholesale_invoice`,
    method: "GET",
    responseType: "blob",
    signal,
  });
};

export const getGetBulkSuborderWholesaleInvoiceQueryKey = (
  bulkSuborderId?: string,
) => {
  return ["api", "bulk_suborder", bulkSuborderId, "wholesale_invoice"] as const;
};

export const getGetBulkSuborderWholesaleInvoiceQueryOptions = <
  TData = Awaited<ReturnType<typeof getBulkSuborderWholesaleInvoice>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborderWholesaleInvoice>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBulkSuborderWholesaleInvoiceQueryKey(bulkSuborderId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBulkSuborderWholesaleInvoice>>
  > = ({ signal }) => getBulkSuborderWholesaleInvoice(bulkSuborderId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!bulkSuborderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBulkSuborderWholesaleInvoice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBulkSuborderWholesaleInvoiceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBulkSuborderWholesaleInvoice>>
>;
export type GetBulkSuborderWholesaleInvoiceQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetBulkSuborderWholesaleInvoice<
  TData = Awaited<ReturnType<typeof getBulkSuborderWholesaleInvoice>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborderWholesaleInvoice>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkSuborderWholesaleInvoice>>,
          TError,
          Awaited<ReturnType<typeof getBulkSuborderWholesaleInvoice>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkSuborderWholesaleInvoice<
  TData = Awaited<ReturnType<typeof getBulkSuborderWholesaleInvoice>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborderWholesaleInvoice>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkSuborderWholesaleInvoice>>,
          TError,
          Awaited<ReturnType<typeof getBulkSuborderWholesaleInvoice>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkSuborderWholesaleInvoice<
  TData = Awaited<ReturnType<typeof getBulkSuborderWholesaleInvoice>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborderWholesaleInvoice>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bulk Suborder Wholesale Invoice
 */

export function useGetBulkSuborderWholesaleInvoice<
  TData = Awaited<ReturnType<typeof getBulkSuborderWholesaleInvoice>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkSuborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkSuborderWholesaleInvoice>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBulkSuborderWholesaleInvoiceQueryOptions(
    bulkSuborderId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update an bulk_suborder's target_ship_by by ID.
 * @summary Update Bulk Suborder Target Ship By
 */
export const updateBulkSuborderTargetShipBy = (
  bulkSuborderId: string,
  params: UpdateBulkSuborderTargetShipByParams,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_suborder/${bulkSuborderId}/target_ship_by`,
    method: "PUT",
    params,
  });
};

export const getUpdateBulkSuborderTargetShipByMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBulkSuborderTargetShipBy>>,
    TError,
    { bulkSuborderId: string; params: UpdateBulkSuborderTargetShipByParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBulkSuborderTargetShipBy>>,
  TError,
  { bulkSuborderId: string; params: UpdateBulkSuborderTargetShipByParams },
  TContext
> => {
  const mutationKey = ["updateBulkSuborderTargetShipBy"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBulkSuborderTargetShipBy>>,
    { bulkSuborderId: string; params: UpdateBulkSuborderTargetShipByParams }
  > = (props) => {
    const { bulkSuborderId, params } = props ?? {};

    return updateBulkSuborderTargetShipBy(bulkSuborderId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBulkSuborderTargetShipByMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBulkSuborderTargetShipBy>>
>;

export type UpdateBulkSuborderTargetShipByMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Bulk Suborder Target Ship By
 */
export const useUpdateBulkSuborderTargetShipBy = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBulkSuborderTargetShipBy>>,
      TError,
      { bulkSuborderId: string; params: UpdateBulkSuborderTargetShipByParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBulkSuborderTargetShipBy>>,
  TError,
  { bulkSuborderId: string; params: UpdateBulkSuborderTargetShipByParams },
  TContext
> => {
  const mutationOptions =
    getUpdateBulkSuborderTargetShipByMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to update a bulk_suborder's ship-to by ID.

A null body resets it to the entity's current address. Rejected once a label exists.
 * @summary Update Bulk Suborder Ship To
 */
export const updateBulkSuborderShipTo = (
  bulkSuborderId: string,
  updateBulkSuborderShipToBody: UpdateBulkSuborderShipToBody,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_suborder/${bulkSuborderId}/ship_to`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateBulkSuborderShipToBody,
  });
};

export const getUpdateBulkSuborderShipToMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBulkSuborderShipTo>>,
    TError,
    { bulkSuborderId: string; data: UpdateBulkSuborderShipToBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBulkSuborderShipTo>>,
  TError,
  { bulkSuborderId: string; data: UpdateBulkSuborderShipToBody },
  TContext
> => {
  const mutationKey = ["updateBulkSuborderShipTo"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBulkSuborderShipTo>>,
    { bulkSuborderId: string; data: UpdateBulkSuborderShipToBody }
  > = (props) => {
    const { bulkSuborderId, data } = props ?? {};

    return updateBulkSuborderShipTo(bulkSuborderId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBulkSuborderShipToMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBulkSuborderShipTo>>
>;
export type UpdateBulkSuborderShipToMutationBody = UpdateBulkSuborderShipToBody;
export type UpdateBulkSuborderShipToMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Bulk Suborder Ship To
 */
export const useUpdateBulkSuborderShipTo = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBulkSuborderShipTo>>,
      TError,
      { bulkSuborderId: string; data: UpdateBulkSuborderShipToBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBulkSuborderShipTo>>,
  TError,
  { bulkSuborderId: string; data: UpdateBulkSuborderShipToBody },
  TContext
> => {
  const mutationOptions = getUpdateBulkSuborderShipToMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to update an bulk_suborder's fulfillment note by ID.
 * @summary Update Bulk Suborder Fulfillment Note
 */
export const updateBulkSuborderFulfillmentNote = (
  bulkSuborderId: string,
  params: UpdateBulkSuborderFulfillmentNoteParams,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_suborder/${bulkSuborderId}/fulfillment_note`,
    method: "PUT",
    params,
  });
};

export const getUpdateBulkSuborderFulfillmentNoteMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBulkSuborderFulfillmentNote>>,
    TError,
    { bulkSuborderId: string; params: UpdateBulkSuborderFulfillmentNoteParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBulkSuborderFulfillmentNote>>,
  TError,
  { bulkSuborderId: string; params: UpdateBulkSuborderFulfillmentNoteParams },
  TContext
> => {
  const mutationKey = ["updateBulkSuborderFulfillmentNote"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBulkSuborderFulfillmentNote>>,
    { bulkSuborderId: string; params: UpdateBulkSuborderFulfillmentNoteParams }
  > = (props) => {
    const { bulkSuborderId, params } = props ?? {};

    return updateBulkSuborderFulfillmentNote(bulkSuborderId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBulkSuborderFulfillmentNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBulkSuborderFulfillmentNote>>
>;

export type UpdateBulkSuborderFulfillmentNoteMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Bulk Suborder Fulfillment Note
 */
export const useUpdateBulkSuborderFulfillmentNote = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBulkSuborderFulfillmentNote>>,
      TError,
      {
        bulkSuborderId: string;
        params: UpdateBulkSuborderFulfillmentNoteParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBulkSuborderFulfillmentNote>>,
  TError,
  { bulkSuborderId: string; params: UpdateBulkSuborderFulfillmentNoteParams },
  TContext
> => {
  const mutationOptions =
    getUpdateBulkSuborderFulfillmentNoteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to update an bulk_suborder's shipping speed by ID.
 * @summary Update Bulk Suborder Shipping Speed
 */
export const updateBulkSuborderShippingSpeed = (
  bulkSuborderId: string,
  params: UpdateBulkSuborderShippingSpeedParams,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_suborder/${bulkSuborderId}/shipping_speed`,
    method: "PUT",
    params,
  });
};

export const getUpdateBulkSuborderShippingSpeedMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBulkSuborderShippingSpeed>>,
    TError,
    { bulkSuborderId: string; params: UpdateBulkSuborderShippingSpeedParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBulkSuborderShippingSpeed>>,
  TError,
  { bulkSuborderId: string; params: UpdateBulkSuborderShippingSpeedParams },
  TContext
> => {
  const mutationKey = ["updateBulkSuborderShippingSpeed"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBulkSuborderShippingSpeed>>,
    { bulkSuborderId: string; params: UpdateBulkSuborderShippingSpeedParams }
  > = (props) => {
    const { bulkSuborderId, params } = props ?? {};

    return updateBulkSuborderShippingSpeed(bulkSuborderId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBulkSuborderShippingSpeedMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBulkSuborderShippingSpeed>>
>;

export type UpdateBulkSuborderShippingSpeedMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Bulk Suborder Shipping Speed
 */
export const useUpdateBulkSuborderShippingSpeed = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBulkSuborderShippingSpeed>>,
      TError,
      { bulkSuborderId: string; params: UpdateBulkSuborderShippingSpeedParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBulkSuborderShippingSpeed>>,
  TError,
  { bulkSuborderId: string; params: UpdateBulkSuborderShippingSpeedParams },
  TContext
> => {
  const mutationOptions =
    getUpdateBulkSuborderShippingSpeedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to transfer a bulk_suborder to a different fulfiller.

Only users with administrate_legrande permission can perform this action.
 * @summary Update Bulk Suborder Fulfiller
 */
export const updateBulkSuborderFulfiller = (
  bulkSuborderId: string,
  params: UpdateBulkSuborderFulfillerParams,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_suborder/${bulkSuborderId}/fulfiller`,
    method: "PUT",
    params,
  });
};

export const getUpdateBulkSuborderFulfillerMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBulkSuborderFulfiller>>,
    TError,
    { bulkSuborderId: string; params: UpdateBulkSuborderFulfillerParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBulkSuborderFulfiller>>,
  TError,
  { bulkSuborderId: string; params: UpdateBulkSuborderFulfillerParams },
  TContext
> => {
  const mutationKey = ["updateBulkSuborderFulfiller"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBulkSuborderFulfiller>>,
    { bulkSuborderId: string; params: UpdateBulkSuborderFulfillerParams }
  > = (props) => {
    const { bulkSuborderId, params } = props ?? {};

    return updateBulkSuborderFulfiller(bulkSuborderId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBulkSuborderFulfillerMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBulkSuborderFulfiller>>
>;

export type UpdateBulkSuborderFulfillerMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Bulk Suborder Fulfiller
 */
export const useUpdateBulkSuborderFulfiller = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBulkSuborderFulfiller>>,
      TError,
      { bulkSuborderId: string; params: UpdateBulkSuborderFulfillerParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBulkSuborderFulfiller>>,
  TError,
  { bulkSuborderId: string; params: UpdateBulkSuborderFulfillerParams },
  TContext
> => {
  const mutationOptions =
    getUpdateBulkSuborderFulfillerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to update a bulk suborder product's unit price.

Only users with administrate_legrande permission can perform this action.
This will recalculate the suborder and order totals and propagate the price to
the order's unpaid standard invoice.
 * @summary Update Bulk Suborder Product Unit Price
 */
export const updateBulkSuborderProductUnitPrice = (
  bulkSuborderId: string,
  bulkSuborderProductId: number,
  params: UpdateBulkSuborderProductUnitPriceParams,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_suborder/${bulkSuborderId}/products/${bulkSuborderProductId}/unit_price`,
    method: "PUT",
    params,
  });
};

export const getUpdateBulkSuborderProductUnitPriceMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBulkSuborderProductUnitPrice>>,
    TError,
    {
      bulkSuborderId: string;
      bulkSuborderProductId: number;
      params: UpdateBulkSuborderProductUnitPriceParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBulkSuborderProductUnitPrice>>,
  TError,
  {
    bulkSuborderId: string;
    bulkSuborderProductId: number;
    params: UpdateBulkSuborderProductUnitPriceParams;
  },
  TContext
> => {
  const mutationKey = ["updateBulkSuborderProductUnitPrice"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBulkSuborderProductUnitPrice>>,
    {
      bulkSuborderId: string;
      bulkSuborderProductId: number;
      params: UpdateBulkSuborderProductUnitPriceParams;
    }
  > = (props) => {
    const { bulkSuborderId, bulkSuborderProductId, params } = props ?? {};

    return updateBulkSuborderProductUnitPrice(
      bulkSuborderId,
      bulkSuborderProductId,
      params,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBulkSuborderProductUnitPriceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBulkSuborderProductUnitPrice>>
>;

export type UpdateBulkSuborderProductUnitPriceMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Bulk Suborder Product Unit Price
 */
export const useUpdateBulkSuborderProductUnitPrice = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBulkSuborderProductUnitPrice>>,
      TError,
      {
        bulkSuborderId: string;
        bulkSuborderProductId: number;
        params: UpdateBulkSuborderProductUnitPriceParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBulkSuborderProductUnitPrice>>,
  TError,
  {
    bulkSuborderId: string;
    bulkSuborderProductId: number;
    params: UpdateBulkSuborderProductUnitPriceParams;
  },
  TContext
> => {
  const mutationOptions =
    getUpdateBulkSuborderProductUnitPriceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to update a bulk suborder product's lot number and expiration date.

Available to fulfillers for their own suborders.
Only allowed when status is Open or Fulfilled.
 * @summary Update Bulk Suborder Product Lot Info
 */
export const updateBulkSuborderProductLotInfo = (
  bulkSuborderId: string,
  bulkSuborderProductId: number,
  params?: UpdateBulkSuborderProductLotInfoParams,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_suborder/${bulkSuborderId}/products/${bulkSuborderProductId}/lot_info`,
    method: "PUT",
    params,
  });
};

export const getUpdateBulkSuborderProductLotInfoMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBulkSuborderProductLotInfo>>,
    TError,
    {
      bulkSuborderId: string;
      bulkSuborderProductId: number;
      params?: UpdateBulkSuborderProductLotInfoParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBulkSuborderProductLotInfo>>,
  TError,
  {
    bulkSuborderId: string;
    bulkSuborderProductId: number;
    params?: UpdateBulkSuborderProductLotInfoParams;
  },
  TContext
> => {
  const mutationKey = ["updateBulkSuborderProductLotInfo"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBulkSuborderProductLotInfo>>,
    {
      bulkSuborderId: string;
      bulkSuborderProductId: number;
      params?: UpdateBulkSuborderProductLotInfoParams;
    }
  > = (props) => {
    const { bulkSuborderId, bulkSuborderProductId, params } = props ?? {};

    return updateBulkSuborderProductLotInfo(
      bulkSuborderId,
      bulkSuborderProductId,
      params,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBulkSuborderProductLotInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBulkSuborderProductLotInfo>>
>;

export type UpdateBulkSuborderProductLotInfoMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Bulk Suborder Product Lot Info
 */
export const useUpdateBulkSuborderProductLotInfo = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBulkSuborderProductLotInfo>>,
      TError,
      {
        bulkSuborderId: string;
        bulkSuborderProductId: number;
        params?: UpdateBulkSuborderProductLotInfoParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBulkSuborderProductLotInfo>>,
  TError,
  {
    bulkSuborderId: string;
    bulkSuborderProductId: number;
    params?: UpdateBulkSuborderProductLotInfoParams;
  },
  TContext
> => {
  const mutationOptions =
    getUpdateBulkSuborderProductLotInfoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update the wholesale price for a specific product within a suborder.

Only users with administrate_legrande permission can perform this action.
The wholesale_price is snapshotted per-suborder, so this only affects the specified suborder.
 * @summary Update Bulk Suborder Product Wholesale Price
 */
export const updateBulkSuborderProductWholesalePrice = (
  bulkSuborderId: string,
  bulkSuborderProductId: number,
  params: UpdateBulkSuborderProductWholesalePriceParams,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_suborder/${bulkSuborderId}/products/${bulkSuborderProductId}/wholesale_price`,
    method: "PUT",
    params,
  });
};

export const getUpdateBulkSuborderProductWholesalePriceMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBulkSuborderProductWholesalePrice>>,
    TError,
    {
      bulkSuborderId: string;
      bulkSuborderProductId: number;
      params: UpdateBulkSuborderProductWholesalePriceParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBulkSuborderProductWholesalePrice>>,
  TError,
  {
    bulkSuborderId: string;
    bulkSuborderProductId: number;
    params: UpdateBulkSuborderProductWholesalePriceParams;
  },
  TContext
> => {
  const mutationKey = ["updateBulkSuborderProductWholesalePrice"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBulkSuborderProductWholesalePrice>>,
    {
      bulkSuborderId: string;
      bulkSuborderProductId: number;
      params: UpdateBulkSuborderProductWholesalePriceParams;
    }
  > = (props) => {
    const { bulkSuborderId, bulkSuborderProductId, params } = props ?? {};

    return updateBulkSuborderProductWholesalePrice(
      bulkSuborderId,
      bulkSuborderProductId,
      params,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBulkSuborderProductWholesalePriceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBulkSuborderProductWholesalePrice>>
>;

export type UpdateBulkSuborderProductWholesalePriceMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Bulk Suborder Product Wholesale Price
 */
export const useUpdateBulkSuborderProductWholesalePrice = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBulkSuborderProductWholesalePrice>>,
      TError,
      {
        bulkSuborderId: string;
        bulkSuborderProductId: number;
        params: UpdateBulkSuborderProductWholesalePriceParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBulkSuborderProductWholesalePrice>>,
  TError,
  {
    bulkSuborderId: string;
    bulkSuborderProductId: number;
    params: UpdateBulkSuborderProductWholesalePriceParams;
  },
  TContext
> => {
  const mutationOptions =
    getUpdateBulkSuborderProductWholesalePriceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Split a bulk suborder product row into two rows.

The original row's quantity is reduced by split_quantity, and a new row is
created with that quantity. This allows assigning different lot numbers to
portions of the same product.
 * @summary Split Bulk Suborder Product
 */
export const splitBulkSuborderProduct = (
  bulkSuborderId: string,
  bulkSuborderProductId: number,
  params: SplitBulkSuborderProductParams,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_suborder/${bulkSuborderId}/products/${bulkSuborderProductId}/split`,
    method: "POST",
    params,
    signal,
  });
};

export const getSplitBulkSuborderProductMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof splitBulkSuborderProduct>>,
    TError,
    {
      bulkSuborderId: string;
      bulkSuborderProductId: number;
      params: SplitBulkSuborderProductParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof splitBulkSuborderProduct>>,
  TError,
  {
    bulkSuborderId: string;
    bulkSuborderProductId: number;
    params: SplitBulkSuborderProductParams;
  },
  TContext
> => {
  const mutationKey = ["splitBulkSuborderProduct"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof splitBulkSuborderProduct>>,
    {
      bulkSuborderId: string;
      bulkSuborderProductId: number;
      params: SplitBulkSuborderProductParams;
    }
  > = (props) => {
    const { bulkSuborderId, bulkSuborderProductId, params } = props ?? {};

    return splitBulkSuborderProduct(
      bulkSuborderId,
      bulkSuborderProductId,
      params,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SplitBulkSuborderProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof splitBulkSuborderProduct>>
>;

export type SplitBulkSuborderProductMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Split Bulk Suborder Product
 */
export const useSplitBulkSuborderProduct = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof splitBulkSuborderProduct>>,
      TError,
      {
        bulkSuborderId: string;
        bulkSuborderProductId: number;
        params: SplitBulkSuborderProductParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof splitBulkSuborderProduct>>,
  TError,
  {
    bulkSuborderId: string;
    bulkSuborderProductId: number;
    params: SplitBulkSuborderProductParams;
  },
  TContext
> => {
  const mutationOptions = getSplitBulkSuborderProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to mark an bulk_suborder as delivered by ID.
 * @summary Mark Bulk Suborder Delivered
 */
export const markBulkSuborderDelivered = (
  bulkSuborderId: string,
  params: MarkBulkSuborderDeliveredParams,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_suborder/${bulkSuborderId}/delivered`,
    method: "POST",
    params,
    signal,
  });
};

export const getMarkBulkSuborderDeliveredMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markBulkSuborderDelivered>>,
    TError,
    { bulkSuborderId: string; params: MarkBulkSuborderDeliveredParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markBulkSuborderDelivered>>,
  TError,
  { bulkSuborderId: string; params: MarkBulkSuborderDeliveredParams },
  TContext
> => {
  const mutationKey = ["markBulkSuborderDelivered"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markBulkSuborderDelivered>>,
    { bulkSuborderId: string; params: MarkBulkSuborderDeliveredParams }
  > = (props) => {
    const { bulkSuborderId, params } = props ?? {};

    return markBulkSuborderDelivered(bulkSuborderId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkBulkSuborderDeliveredMutationResult = NonNullable<
  Awaited<ReturnType<typeof markBulkSuborderDelivered>>
>;

export type MarkBulkSuborderDeliveredMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Mark Bulk Suborder Delivered
 */
export const useMarkBulkSuborderDelivered = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markBulkSuborderDelivered>>,
      TError,
      { bulkSuborderId: string; params: MarkBulkSuborderDeliveredParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markBulkSuborderDelivered>>,
  TError,
  { bulkSuborderId: string; params: MarkBulkSuborderDeliveredParams },
  TContext
> => {
  const mutationOptions = getMarkBulkSuborderDeliveredMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to send a receipt email to the patient for a given order.
 * @summary Send Purchase Suborder Email
 */
export const sendPurchaseSuborderEmail = (
  bulkSuborderId: string,
  sendPurchaseSuborderEmailBody: string[],
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_suborder/${bulkSuborderId}/send_purchase_suborder_email`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: sendPurchaseSuborderEmailBody,
    signal,
  });
};

export const getSendPurchaseSuborderEmailMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendPurchaseSuborderEmail>>,
    TError,
    { bulkSuborderId: string; data: string[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendPurchaseSuborderEmail>>,
  TError,
  { bulkSuborderId: string; data: string[] },
  TContext
> => {
  const mutationKey = ["sendPurchaseSuborderEmail"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendPurchaseSuborderEmail>>,
    { bulkSuborderId: string; data: string[] }
  > = (props) => {
    const { bulkSuborderId, data } = props ?? {};

    return sendPurchaseSuborderEmail(bulkSuborderId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendPurchaseSuborderEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendPurchaseSuborderEmail>>
>;
export type SendPurchaseSuborderEmailMutationBody = string[];
export type SendPurchaseSuborderEmailMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Send Purchase Suborder Email
 */
export const useSendPurchaseSuborderEmail = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendPurchaseSuborderEmail>>,
      TError,
      { bulkSuborderId: string; data: string[] },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendPurchaseSuborderEmail>>,
  TError,
  { bulkSuborderId: string; data: string[] },
  TContext
> => {
  const mutationOptions = getSendPurchaseSuborderEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
